import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/utils/amplitude";
import ActivityCenterBell from "./activity-center-bell";
import Popover from "@Shared/components/general/popover";
import ActivitiesTab from "./tabs/activities-tab.vue";
import ReleaseNotesTab from "./tabs/release-notes-tab.vue";
import { mapActions, mapState } from "vuex";
import { REGISTER_DEVICE, UPDATE_DEVICE_TOKEN, LOAD_REGISTERED_DEVICES, LOAD_CURRENT_DEVICE, LOAD_NOTIFICATIONS, CREATE_NOTIFICATION, DELETE_NOTIFICATION, UPDATE_NOTIFICATION, UPDATE_DEVICE_LAST_SEEN } from "../store/activity-center-actions";
import FirebaseMixin from "../mixins/firebase-notifications";
import { showToast } from "@Shared/utils/constants";
import { filter, isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ActivityCenterContainer",
  components: {
    ActivityCenterBell,
    Popover,
    ActivitiesTab,
    ReleaseNotesTab
  },
  mixins: [FirebaseMixin],
  data() {
    return {
      currentTab: "activities",
      loading: false,
      currentToken: "",
      requestingToken: false,
      notificationPermission: this.getNotificationPermissions(),
      filters: {
        days: 30,
        expired: false
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("ActivityCenterStore", ["registeredDevices", "currentDevice", "followUps", "releaseNotes"])), {}, {
    tabs() {
      return [{
        name: "activities",
        label: this.$t("notifications.tabs.activity")
      }, {
        name: "release-notes",
        label: this.$t("notifications.tabs.releaseNotes")
      }];
    },
    bellStatus() {
      if (!this.followUps.allIds.length) return "clear";
      const statusList = this.$options.filters.activityClass(_Object$values(this.followUps.byId), false);
      return statusList.split(" ").pop();
    },
    bellBadgeCount() {
      const releases = this.releaseNotes.byId;
      const pendingReleaseNotes = filter(releases, {
        read: false
      });
      return pendingReleaseNotes.length;
    }
  }),
  watch: {
    currentTab(val) {
      if (val) {
        const eventName = this.$options.filters.kebabToSentence(val);
        Amplitude.logEvent(`Activity Center - ${eventName} tab opened`, {
          page: "activity-center"
        });
      }
    },
    notificationPermission(val, oldVal) {
      if (val && val !== oldVal) {
        if (val === "granted") {
          return Amplitude.logEvent("Activity Center - notification permission obtained", {
            page: "activity-center"
          });
        }
        if (val === "denied") {
          return Amplitude.logEvent("Activity Center - notification permission rejected", {
            page: "activity-center"
          });
        }
      }
    }
  },
  beforeDestroy() {
    this.$off("show-release-notes");
  },
  async mounted() {
    this.listenForTabChanges();
    this.loadAllNotifications();
    this.listenNotifications(this.handleNotification.bind(this));
    this.LOAD_CURRENT_DEVICE();
    this.LOAD_REGISTERED_DEVICES();
    this.checkCurrentNotificationPermissions();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ActivityCenterStore", [REGISTER_DEVICE, LOAD_REGISTERED_DEVICES, LOAD_CURRENT_DEVICE, LOAD_NOTIFICATIONS, CREATE_NOTIFICATION, UPDATE_DEVICE_TOKEN, DELETE_NOTIFICATION, UPDATE_NOTIFICATION, UPDATE_DEVICE_LAST_SEEN])), {}, {
    showError(e) {
      console.error(e);
      showToast("error", "weWontNotify");
    },
    async handleBellClick() {
      this.$refs.popover.toggle();
      this.checkCurrentNotificationPermissions();
    },
    checkCurrentNotificationPermissions() {
      this.notificationPermission = this.getNotificationPermissions(); // Ensure to check devices, we could refactor this later
      if (this.notificationPermission === "default") return;
      if (this.notificationPermission !== "denied") {
        this.checkToken();
      }
    },
    activeItem(tab) {
      return this.currentTab === tab;
    },
    setCurrentTab(tab) {
      this.currentTab = tab;
    },
    async handlePermissions() {
      this.notificationPermission = await this.promptNotificationPermission();
      if (this.notificationPermission === "granted") return this.checkToken();
      if (this.notificationPermission === "denied") {
        return showToast("info", "notificationsBlocked");
      }
    },
    async checkToken() {
      if (this.requestingToken) return;
      try {
        this.requestingToken = true;
        this.currentToken = await this.getToken();
        this.notificationPermission = this.getNotificationPermissions();
        const {
          deviceId
        } = this.currentDevice;
        const currentDevice = this.registeredDevices.byId[deviceId] || {};
        const deviceNotRegistered = isEmpty(currentDevice);
        const {
          id
        } = currentDevice;
        if (deviceNotRegistered) {
          await this.REGISTER_DEVICE({
            token: this.currentToken
          });
          await this.LOAD_REGISTERED_DEVICES();
        } else {
          const shouldRefreshToken = await this.UPDATE_DEVICE_LAST_SEEN({
            token: this.currentToken,
            id
          });
          if (shouldRefreshToken) {
            await this.UPDATE_DEVICE_TOKEN({
              token: this.currentToken
            });
            await this.LOAD_REGISTERED_DEVICES();
          }
        }
      } catch (e) {
        //ignore
        Amplitude.logHandledError(e);
      } finally {
        this.requestingToken = false;
      }
    },
    handleNotification(notificationData) {
      const {
        origin
      } = notificationData;
      if (origin === "followUp") {
        return this.handleFollowUpNotification(notificationData);
      }
      if (origin === "releaseNote") {
        return this.handleReleaseNoteNotification(notificationData);
      }
    },
    handleFollowUpNotification(data = {}) {
      const type = "followUps";
      const {
        followUp,
        followUpId: id,
        clientProfileId,
        unassigned,
        profileDetails = {}
      } = data;
      if (unassigned) return this.DELETE_NOTIFICATION({
        id,
        type
      });
      const notification = _objectSpread(_objectSpread({
        activityType: "followUp",
        clientProfileId,
        read: false
      }, followUp), profileDetails);
      if (this.followUps.byId[id]) return this.UPDATE_NOTIFICATION({
        type,
        notification,
        id
      });
      this.CREATE_NOTIFICATION({
        type,
        notification,
        id
      });
    },
    handleReleaseNoteNotification(data = {}) {
      const type = "releaseNotes";
      const {
        description,
        id,
        title,
        version
      } = data;
      const notification = {
        activityType: "releaseNote",
        read: false,
        description,
        id,
        title,
        version
      };
      if (this.releaseNotes.byId[id]) return this.UPDATE_NOTIFICATION({
        type,
        notification,
        id
      });
      this.CREATE_NOTIFICATION({
        type,
        notification,
        id
      });
    },
    async loadAllNotifications(args) {
      this.loading = true;
      if (args != null && args.filters) this.filters = _objectSpread({}, args.filters);
      await this.LOAD_NOTIFICATIONS({
        filters: this.filters
      });
      this.loading = false;
    },
    linkClass(tabName) {
      const classes = [];
      if (tabName === "release-notes" && this.bellBadgeCount > 0) {
        classes.push("has-badge");
      }
      return classes.join(" ");
    },
    listenForTabChanges() {
      this.$root.$on("show-release-notes", () => {
        this.currentTab = "release-notes";
        this.handleBellClick();
      });
    }
  })
});